var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItem1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49414 2.67651H15.5059C16.3297 2.67651 17 3.34679 17 4.17065V12.8294C17 13.6533 16.3297 14.3236 15.5059 14.3236H1.49414C0.670271 14.3236 0 13.6533 0 12.8294V4.17065C0 3.34679 0.670271 2.67651 1.49414 2.67651ZM1.68914 3.67261L1.88856 3.83866L7.90719 8.85037C8.25071 9.13638 8.74936 9.13638 9.09281 8.85037L15.1114 3.83866L15.3109 3.67261H1.68914ZM16.0039 4.39172L11.1001 8.47514L16.0039 11.7388V4.39172ZM1.49414 13.3275H15.5059C15.7465 13.3275 15.9478 13.1559 15.9939 12.9287L10.3014 9.14017L9.73018 9.61583C9.37377 9.9126 8.93685 10.061 8.49997 10.061C8.06308 10.061 7.62619 9.9126 7.26976 9.61583L6.69853 9.14017L1.00605 12.9286C1.05221 13.1559 1.25348 13.3275 1.49414 13.3275ZM0.996094 11.7388L5.89993 8.47517L0.996094 4.39172V11.7388Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem1);
export default __webpack_public_path__ + "static/media/item1.d36833230b6b1fd4c10a14d47146945e.svg";
export { ForwardRef as ReactComponent };